import styles from './ProfileHeader.module.css';
import { useNavigate } from 'react-router-dom';
import repeat from './repeat.svg'
import {toast} from "react-toastify";

export default function ProfileHeader({ user, onLogout, generateCode, isCodePending }) {
    const navigate = useNavigate();

    const code = user?.telegramCode ?? '';

    const handleCopy = async () => {
        if (isCodePending) return;
        if (!code) return toast.error("Сначала сгенерируй код");
        await navigator.clipboard.writeText(code);
        toast.success("Код скопирован");
    };


    return (
        <section className={`container-custom ${styles.container}`}>
            <div className={styles.imgWrap}>
                <img
                    className={styles.avatar}
                    src={user?.imageUrl || '/images/plug.avif'}
                    alt="Фото профиля"
                />
            </div>
            <div className={styles.info}>
                <p className={styles.name}>{user?.name} {user?.surname}</p>
                <h3 className={styles.text}>{user?.dateOfBirth}</h3>
                <h3 className={styles.text}>ID {user?.id?.toString().padStart(4,'0')}</h3>
                <div className={`d-flex justify-content-between align-items-center ${styles.code}`}>
                    <h3 className={styles.text}>Код для входа в telegramм</h3>

                    <div
                        className={styles.block}>
                        <h3
                            onClick={handleCopy}
                        >
                            {isCodePending
                                ? "Загрузка..."
                                : user?.telegramCode
                            }

                        </h3>
                        <img
                            onClick={() => !isCodePending && generateCode()}
                            style={{ opacity: isCodePending ? 0.5 : 1, cursor: isCodePending ? "not-allowed" : "pointer" }}
                            src={repeat}
                            alt="Сгенерировать"
                        />
                    </div>
                </div>
            </div>

            <div className={`row ${styles.buttons}`}>
                <button className="btn btn-green-filled" onClick={() => navigate('/profile/edit')}>
                    Редактировать
                </button>
                <button className="btn btn-red-outline" onClick={onLogout}>
                    Выйти
                </button>
            </div>
        </section>
    );
}